import { render } from "./BlackjackTournamentDialog.vue?vue&type=template&id=8c871a18&scoped=true"
import script from "./BlackjackTournamentDialog.vue?vue&type=script&lang=js"
export * from "./BlackjackTournamentDialog.vue?vue&type=script&lang=js"

import "./BlackjackTournamentDialog.vue?vue&type=style&index=0&id=8c871a18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c871a18"]])

export default __exports__